import { 
    apiBizGetEditHouseList,
    apiBizInsertEditHouse,
    apiBizInsertHouseImage,
    apiBizDelHouseImage,
    apiBizDelHouse,
    apiBizPublishHouse,
    apiBizInsertEditHouseNoReview,
    apiBizBatchHouse
} from "@/apis/api.js"; 
import { 
    uploadVideo,
    uploadHouseAttorney
} from "@/apis/company/houseMgt.js"; 

import router from '@/router'

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    get_house_default: 'bizEditHouse/get_house_default',
    set_house_list: 'bizEditHouse/set_house_list',
    set_image_files: 'bizEditHouse/set_image_files',
    set_image_cover: 'bizEditHouse/set_image_cover',
    set_video: 'bizEditHouse/set_video',
    set_landlord_auth: 'bizEditHouse/set_landlord_auth',
    set_del_image: 'bizEditHouse/set_del_image',
    set_del_cover: 'bizEditHouse/set_del_cover',
    set_house_cid: 'bizEditHouse/set_house_cid',
    set_house_policy: 'bizEditHouse/set_house_policy',
    set_save_fail: 'bizEditHouse/set_save_fail',
    set_save_success: 'bizEditHouse/set_save_success',
    set_save_type: 'bizEditHouse/set_save_type',
    set_contract_version_mode: 'bizEditHouse/set_contract_version_mode',
}

// count state 必須是 Object
const state = {
    savetype: 'REVEIW',
    houseDefaultList: null,
    houseList: [],
    imageFiles: [],
    cover: 0,
    covers: [],
    video: null,
    landlordAuth: null,
    delImg: [],
    delCover: false,
    houseCid: '',
    contractVersionMode: null,
    error: {
        state: false,
        msg: '儲存失敗，請再試一次'
    },
    success: {
        state: false,
        msg: '下架成功'
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_EDIT_HOUSE_STATUS: (state) => {
        return state.houseDefaultList?state.houseDefaultList.houseStatus:null
    },
    GET_BIZ_EDIT_FEATURES: (state) => {
        return state.houseDefaultList?state.houseDefaultList.features:null
    },
    GET_BIZ_EDIT_EQUIPS: (state) => {
        return state.houseDefaultList?state.houseDefaultList.equips:null
    },
    GET_BIZ_EDIT_RENT_INCLUDE: (state) => {
        return state.houseDefaultList?state.houseDefaultList.rentInclude:null
    },
    GET_BIZ_EDIT_BUILDING_TYPE: (state) => {
        return state.houseDefaultList?state.houseDefaultList.buildingTypeList:null
    },
    GET_BIZ_EDIT_HOUSE_TYPE: (state) => {
        return state.houseDefaultList?state.houseDefaultList.houseTypeList:null
    },
    GET_BIZ_EDIT_SPECIAL_TYPE: (state) => {
        return state.houseDefaultList?state.houseDefaultList.specialTypeList:null
    },
    GET_BIZ_EDIT_HOUSE_POLICY: (state) => {
        return state.houseDefaultList?state.houseDefaultList.caseHousePolicyDto.policySettingUseDtoList:null
    },
    GET_BIZ_EDIT_DESPOSIT_POLICY: (state) => {
        return state.houseDefaultList?state.houseDefaultList.caseDepositPolicyDto.policySettingUseDtoList:null
    },
    GET_BIZ_EDIT_HOUSE_DEFAULT: (state) => {
        return state.houseDefaultList?state.houseDefaultList.houseDataEditDto:null
    },
    GET_BIZ_EDIT_HOUSE_BILL_CHRAGE_MODE: (state) => {
        return state.houseDefaultList?state.houseDefaultList.billChargeMode:null
    },
    GET_BIZ_EDIT_ERROR_STATE: (state) => {
        return state.error
    },
    GET_BIZ_EDIT_SUCCESS_STATE: (state) => {
        return state.success
    },
    GET_BIZ_EDIT_HOUSE_COMPELETE: (state) => {
        return state.houseDefaultList?state.houseDefaultList.complete:null
    },
    GET_BIZ_EDIT_HOUSE_PUBLISH: (state) => {
        return state.houseDefaultList?state.houseDefaultList.houseDataEditDto.publish:null
    },
    GET_BIZ_EDIT_RENT_PERIOD_LIST: (state) => {
        return state.houseDefaultList?state.houseDefaultList.houseDataEditDto.rentPeriodList:null
    },
    GET_BIZ_EDIT_CONTRACT_VERSION_MODE: (state) => {
        return state.contractVersionMode
    },
    GET_BIZ_EDIT_HOUSE_HAS_IMAGE: (state) => {
        // console.log(state.delCover)
        // console.log(delCoverCount)
        let defaultImgCount = state.houseDefaultList?state.houseDefaultList.houseDataEditDto.houseImageListList.length:0
        let delImgCount = state.delImg.length
        let imgCount = defaultImgCount+ state.imageFiles.length
        // console.log(delImgCount)
        // console.log(defaultImgCount)
        if(delImgCount < imgCount){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_EDIT_HOUSE_HAS_COVER: (state) => {
        let cover = state.houseDefaultList?state.houseDefaultList.houseDataEditDto.houseCoverImage:null
      
        if(cover || state.covers.length > 0){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_EDIT_HOUSE_HAS_CHANGE_COVER: (state) => {
        let cover = state.houseDefaultList?state.houseDefaultList.houseDataEditDto.houseCoverImage:''
        let coverName = cover.split(/(\\|\/)/g).pop()
        if(coverName == 'default.png' && state.covers.length == 0){
            return false
        }else{
            return true
        }
    },
    // GET_BIZ_EDIT_HOUSE_MOVE_IN_DATE_START: (state) => {
    //     return state.houseDefaultList.houseDataEditDto.startDate - 28800000
    // },
    
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizEditHouseDefault ( {commit, state} ) {
        return new Promise((resolve, reject) => {
            apiBizGetEditHouseList(state.houseCid)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result
                    commit(types.get_house_default, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getBizEditHousePolicy ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetEditHouseList(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.caseHousePolicyDto.policySettingUseDtoList
                    commit(types.set_house_policy, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizHouseCid ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_house_cid, data);
            resolve()
        })
    },
    setBizSaveType ({commit}, data) {
        return new Promise((resolve, reject) => {
            commit(types.set_save_type, data);
            resolve()
        })
    },
    setBizEditPublish( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            let obj = {
                "houseCid": state.houseCid,
                "status": data
            }
            apiBizPublishHouse(obj)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(data)
                    if(data == 'HIDE'){
                        commit(types.set_save_success, {status: true, msg: '下架成功'})
                        dispatch('getBizEditHouseDefault')
                    }
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                                        dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizEditHouseList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_house_list, data);
            resolve()
        })
    },
    setBizEditImageFiles ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_image_files, data);
            resolve()
        })
    },
    setBizEditImageCovers ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_image_cover, data);
            resolve()
        })
    },
    setBizEditDelImage ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_del_image, data);
            resolve()
        })
    },
    setBizEditDelCover ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_del_cover, true);
            resolve()
        })
    },
    setBizEditCover ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_cover, data);
            resolve() 
        })
    },
    saveBizEditHouse ( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            apiBizInsertEditHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if(state.video && state.video.length > 0){
                        dispatch('saveBizEditVideo', state.houseCid )
                        .then( () => {
                        })
                    }
                    if(state.landlordAuth && state.landlordAuth.length > 0){
                        dispatch('saveBizEditLandlordAuth', state.houseCid )
                        .then( () => {
                        })
                    }
                    dispatch('delBizEditCover')
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    reject()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveBizEditHouseNoReview ( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            apiBizInsertEditHouseNoReview(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if(state.video && state.video.length > 0){
                        dispatch('saveBizEditVideo', state.houseCid )
                        .then( () => {
                            // resolve()
                        })
                    }
                    if(state.landlordAuth && state.landlordAuth.length > 0){
                        dispatch('saveBizEditLandlordAuth', state.houseCid )
                        .then( () => {
                            // resolve()
                        })
                    }
                    dispatch('delBizEditCover')
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    reject()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    deleteBizEditHouse ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            apiBizDelHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveBizEditImage ( {commit, state, dispatch} ) {
        return new Promise((resolve, reject) => {
            console.log('上傳圖片張數:'+state.imageFiles.length)
            console.log(router.currentRoute)
            if(state.imageFiles.length > 0){
                console.log('SaveImg')
                    
                state.imageFiles.map( (image, index) => {
                    
                    let formData = new FormData();
                        formData.append('houseImage', image.file);
                        formData.append('houseCid', state.houseCid);
                        formData.append('imageSeq', '1');
                         for (var key of formData.keys()) {
                            console.log('content:'+key); 
                         }
                        for (var value of formData.values()) {
                            console.log('content:'+value); 
                         }
                    apiBizInsertHouseImage(formData)
                    .then(res => {
                        console.log(res)
                        // console.log(state.imageFiles.length)
                        // console.log(index+1)
                        if( index+1 == state.imageFiles.length){
                                // window.location.reload(); 
                                dispatch('setBizEditImageFiles', [])
                                if(state.saveType == 'REVIEW'){
                                    
                                    dispatch('setBizEditPublish', 'REVEAL')
                                    .then(() => {
                                        dispatch('setLoadingState', 0)
                                        resolve()
                                    })
                                }else{
                                    dispatch('setLoadingState', 0)
                                    resolve()
                                }
                        }
                    })
                    .catch(err => {
                        reject(err)
                    })
                })
            }else{
                console.log('noImg')
                if(state.saveType == 'REVIEW'){
                    dispatch('setBizEditPublish', 'REVEAL')
                    .then(() => {
                        // router.push({ name: 'bizHouseMgtDefault'})
                        dispatch('setLoadingState', 0)
                        resolve()
                    })
                }else{
                    console.log('123')
                    // router.push({ name: 'bizHouseMgtDefault'})
                    dispatch('setLoadingState', 0)
                    resolve()
                }
                    // window.location.reload(); 
            }
        })
    },
    saveBizEditCover ( {commit, state, dispatch} ) {
        return new Promise((resolve, reject) => {
            console.log('cover')
            console.log(state.covers.length)

            if(state.covers.length > 0){
                let formData = new FormData();
                    formData.append('houseCid', state.houseCid);
                    formData.append('headImage', state.covers[0].file);
                        
                    // for (var key of formData.keys()) {
                    //     console.log('cover:'+key); 
                    //  }
                    // for (var value of formData.values()) {
                    //     console.log('cover:'+value); 
                    //  }
                console.log('cover')
                apiBizBatchHouse(formData)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        dispatch('saveBizEditImage')
                        dispatch('setBizEditImageCovers', [])
                        resolve()
                    }else{
                        dispatch('setLoadingState', 0)
                        dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
                .catch(err => {
                    reject(err)
                })
            }else{
                dispatch('saveBizEditImage')
            }
        })
    },
    delBizEditImage ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            if(state.delImg.length > 0){
                console.log('DelImg')

                state.delImg.map( (image, index) => {
                    console.log(state.delImg.length)
                    console.log(index)
                    let data = '?imageCid='+image
                    // console.log(data)
                    apiBizDelHouseImage(data)
                    .then(res => {
                        console.log(res)
                        if(res.data.status == "SUCCESS"){
                            if( index+1 == state.delImg.length){
                                dispatch('saveBizEditCover')
                                resolve()
                            }
                        }else{
                            dispatch('setLoadingState', 0)
                            dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                        }
                        
                    })
                    .catch(err => {
                        reject(err)
                    })
                })
            }else{
                console.log('noDelImg')
                dispatch('saveBizEditCover')
            }
            // dispatch('saveEditImage')
        })
    },
    delBizEditCover( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            if(state.delCover){
                console.log('delCover')
                let data = '?houseCid='+state.houseCid
                apiBizDelHouseImage(data)
                .then(res => {
                    // console.log(res)
                // console.log('delCoverAPI')

                    if( res.data.status == "SUCCESS" ){
                        // state.covers = []
                        dispatch('delBizEditImage')
                        resolve()
                    }else{
                        dispatch('setLoadingState', 0)
                        dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
                .catch(err => {
                    reject(err)
                })
            }else{
                console.log('noDelCover')
                dispatch('delBizEditImage')
            }
            // dispatch('saveEditImage')
        })
    },
    saveBizEditLandlordAuth ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let houseCid = data,
            houseAttorney = state.landlordAuth.length?state.landlordAuth[0].file:null

            formData.append('houseCid', houseCid);
            formData.append('houseAttorney', houseAttorney);
            console.log('houseCid', houseCid)
            console.log('houseAttorney', houseAttorney)
            uploadHouseAttorney(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveBizEditVideo ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let houseCid = data,
            houseFilm = state.video.length?state.video[0].file:null

            formData.append('houseCid', houseCid);
            formData.append('houseFilm', houseFilm);
            uploadVideo(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizEditVideo( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_video, data);
        })
    },
    setBizEditLandlordAuth( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_landlord_auth, data);
        })
    },
    setBizEditContractVersionMode( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_version_mode, data);
        })
    },
}

// mutations
const mutations = {
    [types.get_house_default](state, data){
        state.houseDefaultList = data
    },
    [types.set_house_list](state, data){
        state.houseList = data
    },
    [types.set_image_files](state, data){
        state.imageFiles = data
    },
    [types.set_image_cover](state, data){
        state.covers = data
    },
    [types.set_del_image](state, data){
        state.delImg = data
    },
    [types.set_del_cover](state, data){
        state.delCover = data
    },
    [types.set_video](state, data){
        state.video = data
    },
    [types.set_landlord_auth](state, data){
        state.landlordAuth = data
    },
    [types.set_house_cid](state, data){
        state.houseCid = data
    },
    [types.set_house_policy](state, data){
        state.houseDefaultList.caseHousePolicyDto.policySettingUseDtoList = data
    },
    [types.set_save_fail](state, data){
        if(data.status){
            state.error.state = true
            state.error.msg = data.msg
        }else{
            state.error.state = false
            state.error.msg = ''
        }
        
    },
    [types.set_save_success](state, data){
        if(data.status){
            state.success.state = true
            state.success.msg = data.msg
        }else{
            state.success.state = false
            state.success.msg = ''
        }
    },
    [types.set_save_type](state, data){
        state.saveType = data
    },
    [types.set_contract_version_mode](state, data){
        state.contractVersionMode = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseMgt/editHouse.js